module.exports = __webpack_public_path__ + "media/src/images/mails/google_plus-a2dcdd2f4570f86dc82715bad8c2c4e4.png";